module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_Agencies_ReadAll') &&
    !_vm.globals.isLocalAgencyUser
  ) ? _c('div', [_c('div', [_c('agency-management-toolbar', {
    ref: "agencyManagementToolbar",
    attrs: {
      "table-element-count": _vm.tableElementCount,
      "agencySelected": _vm.agencySelected,
      "refreshEnabled": _vm.refreshEnabled
    },
    on: {
      "searchTextChanged": _vm.onSearchTextChanged,
      "pageSizeChanged": _vm.onPageSizeChanged,
      "pageNumberChanged": _vm.onPageNumberChanged,
      "openEditAgency": _vm.toggleModal,
      "openDeleteAgency": function($event) {
        _vm.showDeleteModal = true
      },
      "onTriggerReload": _vm.triggerReload,
      "hook:mounted": _vm.readComponentSettingsFromStore
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('agency-management-table', {
    ref: "agencyManagementTable",
    attrs: {
      "table-filter": _vm.tableFilter,
      "page-size": _vm.pageSize,
      "page-number": _vm.pageNumer,
      "selectedAgency": _vm.selectedAgency
    },
    on: {
      "onTableElementsCountChange": _vm.onTableElementsCountChange,
      "onAgencySelected": _vm.onAgencySelected,
      "onAgencyOpenEdit": _vm.onAgencyOpenEdit,
      "onRefreshEnabled": _vm.onRefreshEnabled,
      "agenciesReceived": function($event) {
        _vm.agencyList = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('agency-management-edit-modal', {
    attrs: {
      "show-edit-modal": _vm.showEditModal,
      "mode-add": _vm.modeAdd,
      "edit-agency-model": _vm.selectedAgency,
      "allRegions": _vm.allRegions,
      "agencyList": _vm.agencyList
    },
    on: {
      "modalClosed": _vm.onModalClosed,
      "onAgencySaved": _vm.onAgencySaved
    }
  }), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.AM0000,
      "yesButtonText": _vm.lang.AM0002,
      "noButtonText": _vm.lang.AM0003,
      "showDialog": _vm.showDeleteModal,
      "colorRed": true
    },
    on: {
      "onYesConfirmation": _vm.onAgencyDeleted,
      "dialogClosed": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.AM0001))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0004))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.selectedAgency.AgencyId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0005))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedAgency.AgencyName) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0006))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedAgency.AgencySince) + "\n      ")])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b554006","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgencyManagement/AgencyManagement.vue
// module id = 1669
// module chunks = 1